
import '../../main.css'
import './ServicesListCard.css'
import './MServicesListCard.css'
import { lP, oP } from '../../main.js'


export default function ServicesListCard(props) {

    let reversecss = (props.chorder != true) ? '' : 'reverseserviceslistcard'

    return (
        <div className={'serviceslistcard ' + props.className + ' ' + reversecss} >
            {/* onClick={() => props.onclick()} */}
            {/* noselect */}
            {/* <div className='serviceslistcard'> */}
            <img className='serviceslistcardimg' src={props.iconimg} alt={"Service-Icon mit dem jeweiligen Symbol für die angebotene Leistung"} />
            <div className='serviceslistcardtextcont'>
                <b>{props.title}</b>
                <p>{props.description}</p>
            </div>
        </div>
        // </div >
    )
}